import { ReactNode } from 'react'

import { expandedSideNavContext } from '../../contexts'
import { useLocalStorage } from 'react-use'

interface ExpandedSideNavProviderProps {
  children: ReactNode
}


// Provides children with "expanded side nav" context
function ExpandedSideNavProvider({ children }: ExpandedSideNavProviderProps) {
  // This value is stored in local storage
  const [expandedSideNav, setExpandedSideNav] = useLocalStorage(
    'expanded-side-nav',
    true
  )

  // Note: Both value and setter are passed down to consumers
  return (
    <expandedSideNavContext.Provider
      value={[expandedSideNav, setExpandedSideNav]}
    >
      {children}
    </expandedSideNavContext.Provider>
  )
}


export default ExpandedSideNavProvider
